import React from 'react';
import { FaCheck } from 'react-icons/fa';
import styles from './PackageParts.module.css';

const PackageParts = ({ title, description, partsList = [] }) => {
  return (
    <section className={styles.packagePartsSection}>
      <div className={styles.contentContainer}>
        
        {/* Header Section */}
        {(title || description) && (
          <div className={styles.headerSection}>
            {title && (
              <h3 className={styles.sectionTitle}>{title}</h3>
            )}
            
            {description && (
              <p className={styles.description}>{description}</p>
            )}
          </div>
        )}

        {/* Parts List Section */}
        {partsList.length > 0 && (
          <div className={styles.partsListSection}>
            <ul className={styles.partsList}>
              {partsList.map((part, index) => (
                <li key={index} className={styles.partItem}>
                  <span className={styles.partText}>{part}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </section>
  );
};

export default PackageParts;